class Accordion {
  /**
   * @constructor
   * @param {any}     element
   *
   * @param {Object}  settings - Settings that can be overwritten
   * @param {string}  [settings.items] - Each accordion item
   * @param {string}  [settings.trigger] - Item trigger that opens/closes accordion
   * @param {string}  [settings.content] - Item content wrapper
   *
   * @param {Object}  [settings.classes] - General classes in use
   * @param {string}  [settings.classes.open] - Open state
   */

  constructor(element, settings) {
    this.element = element;
    this.options = { ...Accordion.defaults(), ...settings };

    this.items = element.querySelectorAll(this.options.items);

    // Bail early if no items
    if (this.items.length === 0) return;

    this.init();
  }

  /**
   * Default settings
   * @returns {object}
   */

  static defaults() {
    return {
      items: '[data-item]',
      trigger: '[data-trigger]',
      content: '[data-content]',
      classes: {
        open: 'is-open',
      },
    };
  }

  /**
   * Init accordion
   */

  init() {
    this.items.forEach((item) => {
      const trigger = item.querySelector(this.options.trigger);
      const content = item.querySelector(this.options.content);

      if (!trigger) Accordion.errorHandling(this.options.trigger);
      if (!content) Accordion.errorHandling(this.options.content);

      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        // Get style of content
        const style = window.getComputedStyle(content);
        const contentOverflow = style.getPropertyValue('overflow');

        // Only trigger toggle if overflow:hidden is set
        if (contentOverflow === 'hidden') this.toggle(item, content);
      });
    });
  }

  /**
   * Toggle content
   * @param {*} item
   * @param {*} content
   */

  toggle(item, content) {
    item.classList.toggle(this.options.classes.open);

    // Set height before triggering 'fixes jumping' bug
    if (!item.classList.contains(this.options.classes.open)) {
      content.style.height = `${content.scrollHeight}px`;
    }

    // Wait for height to be set
    setTimeout(() => {
      content.style.height = item.classList.contains(this.options.classes.open) ? `${content.scrollHeight}px` : 0;
    }, 5);

    content.addEventListener('transitionend', () => {
      if (item.classList.contains(this.options.classes.open)) content.style.height = 'auto';
    }, { once: true });
  }

  /**
   * Error handling
   * @param {*} item
   */

  static errorHandling(item) {
    const type = item.indexOf('[') !== -1 ? 'attribute' : 'class';

    // eslint-disable-next-line no-console
    console.warn(`Accordion couldn't find DOM element by ${type} with "${item}"`);
  }
}

export default (element, settings) => new Accordion(element, settings);
